module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.0ec19322.svg";